/**
 * This code was  originally copied from the lexical playground source code on github
 * And so it doesn't follow our code style
 * https://github.com/facebook/lexical/tree/main/packages/lexical-playground
 *
 */

import { addClassNamesToElement } from "@lexical/utils";
import type {
    DOMConversionMap,
    DOMConversionOutput,
    DOMExportOutput,
    EditorConfig,
    LexicalNode,
    SerializedElementNode,
} from "lexical";
import { ElementNode } from "lexical";

type SerializedArticleContentNode = SerializedElementNode;

export function convertArticleContentElement(domNode: HTMLElement): DOMConversionOutput | null {
    const node = $createArticleContentNode();
    return {
        node,
    };
}

export class ArticleContentNode extends ElementNode {
    static getType(): string {
        return "article-content";
    }

    static clone(node: ArticleContentNode): ArticleContentNode {
        return new ArticleContentNode(node.__key);
    }

    createDOM(config: EditorConfig): HTMLElement {
        const dom = document.createElement("div");
        addClassNamesToElement(dom, config.theme.articleContent);
        return dom;
    }

    updateDOM(prevNode: ArticleContentNode, dom: HTMLElement): boolean {
        return false;
    }

    static importDOM(): DOMConversionMap | null {
        return {
            div: (domNode: HTMLElement) => {
                if (!domNode.hasAttribute("data-lexical-article-content")) {
                    return null;
                }
                return {
                    conversion: convertArticleContentElement,
                    priority: 2,
                };
            },
        };
    }

    exportDOM(): DOMExportOutput {
        const element = document.createElement("div");
        addClassNamesToElement(element, "Article__content");
        element.setAttribute("data-lexical-article-content", "true");
        return { element };
    }

    static importJSON(serializedNode: SerializedArticleContentNode): ArticleContentNode {
        return $createArticleContentNode();
    }

    isShadowRoot(): boolean {
        return true;
    }

    exportJSON(): SerializedArticleContentNode {
        return {
            ...super.exportJSON(),
            type: "article-content",
            version: 1,
        };
    }
}

export function $createArticleContentNode(): ArticleContentNode {
    return new ArticleContentNode();
}

export function $isArticleContentNode(node: LexicalNode | null | undefined): node is ArticleContentNode {
    return node instanceof ArticleContentNode;
}
